// extracted by mini-css-extract-plugin
export default {"answers":"style_answers__BVaFJ","questionCard":"style_questionCard__vwe5p"};